(function() {
    'use strict';

    angular
        .module('app')
        .directive('focus', focus);

    focus.$inject = ['$timeout'];
    
    function focus($timeout) {
        // Usage:
        //     <focus></focus>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            $timeout(function () {
                if (element)
                    element.focus();
            }, 500);
        }
    }

})();